module.exports = __webpack_public_path__ + "img/nadya-brandaus.35061418.jpg";